import { useOnlineOrdersWatcher } from "@/hooks/useOnlineOrdersWatcher";

/**
 * Runs the online-orders poll for the whole app. Renders nothing: it exists
 * because the hook needs the store and toast providers, which `App` itself
 * sits above.
 */
export const OnlineOrdersWatcher = () => {
  useOnlineOrdersWatcher();
  return null;
};

export default OnlineOrdersWatcher;
